<template>
  <div class="subTitleContainer">
    <div class="subTitle">CARDIAC HEALTH SYMPTOMS</div>
    <div class="assessmentHint">
      Have you been experiencing any of the following symptoms
      <b
        >0 = None&nbsp; &nbsp; 1 = Mild&nbsp; &nbsp; 2 = Moderate&nbsp; &nbsp; 3
        = Severe</b
      >
    </div>
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Chest pain or tightness"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.cardioQnr.cardiac_health_symptoms.chest_pain"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('cardiac_health_symptoms.chest_pain', $event)
      "
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Shortness of breath"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.cardioQnr.cardiac_health_symptoms.shortness_of_breath"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('cardiac_health_symptoms.shortness_of_breath', $event)
      "
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Fatigue or weakness"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.cardioQnr.cardiac_health_symptoms.fatigue"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('cardiac_health_symptoms.fatigue', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Lightheadedness or unusual fatigue during or after exercise"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.cardioQnr.cardiac_health_symptoms.lightheadedness"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('cardiac_health_symptoms.lightheadedness', $event)
      "
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Elevated systemic blood pressure"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="
        this.cardioQnr.cardiac_health_symptoms.elevated_systemic_blood_pressure
      "
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange(
          'cardiac_health_symptoms.elevated_systemic_blood_pressure',
          $event
        )
      "
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Rapid or irregular heartbeat"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.cardioQnr.cardiac_health_symptoms.irregular_heartbeat"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('cardiac_health_symptoms.irregular_heartbeat', $event)
      "
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Palpitations"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.cardioQnr.cardiac_health_symptoms.palpitations"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('cardiac_health_symptoms.palpitations', $event)
      "
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Dizziness or fainting"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.cardioQnr.cardiac_health_symptoms.dizziness"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('cardiac_health_symptoms.dizziness', $event)"
    />
  </div>
  <div class="subTitleContainer">
    <div class="subTitle">SYSTEMIC SYMPTOMS</div>
    <div class="assessmentHint">
      Have you been experiencing any of the following symptoms
      <b
        >0 = None&nbsp; &nbsp; 1 = Mild&nbsp; &nbsp; 2 = Moderate&nbsp; &nbsp; 3
        = Severe</b
      >
    </div>
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Hyperpigmented skin patches"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.cardioQnr.systemic_symptoms.skin_hyperpigmentation"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('systemic_symptoms.skin_hyperpigmentation', $event)
      "
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Sudden weight fluctuations (unexpected gain or loss)"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.cardioQnr.systemic_symptoms.weight_fluctuations"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('systemic_symptoms.weight_fluctuations', $event)
      "
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Persistent feeling of hunger or lack of satiety"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.cardioQnr.systemic_symptoms.persistent_hunger"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('systemic_symptoms.persistent_hunger', $event)
      "
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Swelling in the hands, feet, or face (edema)"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.cardioQnr.systemic_symptoms.edema"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('systemic_symptoms.edema', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Altered urinary patterns (frequency, urgency, or amount)"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.cardioQnr.systemic_symptoms.urinary_changes"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('systemic_symptoms.urinary_changes', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Brain fog"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.cardioQnr.systemic_symptoms.brain_fog"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('systemic_symptoms.brain_fog', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Yellowing of the skin or eyes"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.cardioQnr.systemic_symptoms.jaundice"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('systemic_symptoms.jaundice', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Right upper abdominal discomfort or pain"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.cardioQnr.systemic_symptoms.abdominal_pain"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('systemic_symptoms.abdominal_pain', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Frequent infections"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.cardioQnr.systemic_symptoms.frequent_infections"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('systemic_symptoms.frequent_infections', $event)
      "
    />
  </div>
  <div class="subTitleContainer">
    <div class="subTitle">MEDICAL HISTORY</div>
  </div>
  <div class="subpartContainer col-container">
    <QuestionnaireMultiChoice
      content="Do you have a family history of any of the following conditions?"
      width="fit-content"
      mobileWidth="fit-content"
      :options="cardioRelatedFamilyHistoryOptions"
      :value="this.familyHistoryArray"
      :disabled="this.qnrIsCompleted"
      @onChange="handleFamilyHistoryChange"
    />
  </div>
  <div
    class="expandedContainer"
    v-if="this.familyHistoryArray.includes('other')"
  >
    <div class="mb-[10px]">Please specify</div>
    <el-input
      v-model="
        this.cardioQnr.medical_history.family_history.other_family_conditions
      "
      class="expandInputField"
      :type="this.dynamic_input_type"
      :disabled="this.qnrIsCompleted"
      @input="
        handleValueChange(
          'medical_history.family_history.other_family_conditions',
          $event
        )
      "
    />
  </div>
  <div class="subpartContainer col-container">
    <QuestionnaireMultiChoice
      content="Have you been diagnosed with any of the following conditions?"
      width="fit-content"
      mobileWidth="fit-content"
      :options="cardioRelatedConditionOptions"
      :value="this.personalHistoryArray"
      :disabled="this.qnrIsCompleted"
      @onChange="handlePersonHistoryChange"
    />
  </div>
  <div
    class="expandedContainer"
    v-if="this.personalHistoryArray.includes('other')"
  >
    <div class="mb-[10px]">Please specify</div>
    <el-input
      v-model="
        this.cardioQnr.medical_history.personal_history
          .other_personal_conditions
      "
      class="expandInputField"
      :type="this.dynamic_input_type"
      :disabled="this.qnrIsCompleted"
      @input="
        handleValueChange(
          'medical_history.personal_history.other_personal_conditions',
          $event
        )
      "
    />
  </div>
  <div class="subpartContainer !items-start" id="required-questions">
    <QuestionnaireRadio
      content="Have you had your blood pressure checked recently?<div class='mt-1 text-[#ff1d00] max-w-[520px] font-normal'>*Selecting no will result in absence of 10 yr risk scores on your report.</div><div class='mt-[2px] text-[#ff1d00] max-w-[520px] font-normal'>*Required for populating reference ranges and appropriate report comments.</div>"
      width="132px"
      mobileWidth="163px"
      :options="yesNoOptions"
      :value="this.cardioQnr.medical_history.blood_pressure_checked"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('medical_history.blood_pressure_checked', $event)
      "
    />
  </div>
  <div
    class="expandedContainer"
    v-if="this.cardioQnr.medical_history.blood_pressure_checked"
  >
    <div class="mb-[10px]">If yes, please specify</div>
    <div class="grid grid-cols-2 gap-5">
      <div class="flex items-center">
        <div class="mr-1">Systolic:</div>
        <el-input
          v-model="this.cardioQnr.medical_history.systolic"
          class="expandInputField !h-[40px]"
          type="text"
          :disabled="this.qnrIsCompleted"
          placeholder="000"
          @input="handleNumberInput('medical_history.systolic', $event)"
        />
      </div>
      <div class="flex items-center">
        <div class="mr-1">Diastolic:</div>
        <el-input
          v-model="this.cardioQnr.medical_history.diastolic"
          class="expandInputField !h-[40px]"
          type="text"
          :disabled="this.qnrIsCompleted"
          placeholder="000"
          @input="handleNumberInput('medical_history.diastolic', $event)"
        />
      </div>
    </div>
  </div>
  <div
    class="subpartContainer mt-[-10px]"
    id="require-questions"
    v-show="showWarning"
  >
    <SimplifiedNotification build_in_theme="red" :with_close_btn="false">
      <template #content>
        <span class="text-red-500" :class="{ 'text-[12px]': isMobile }">
          This is a mandatory question.
        </span>
      </template>
    </SimplifiedNotification>
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Have you had any heart-related surgeries or procedures?"
      width="132px"
      mobileWidth="163px"
      :options="yesNoOptions"
      :value="this.cardioQnr.medical_history.has_heart_surgeries"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('medical_history.has_heart_surgeries', $event)
      "
    />
  </div>
  <div
    class="expandedContainer"
    v-if="this.cardioQnr.medical_history.has_heart_surgeries"
  >
    <div class="mb-[10px]">Please specify</div>
    <el-input
      v-model="this.cardioQnr.medical_history.heart_surgery_details"
      class="expandInputField"
      :type="this.dynamic_input_type"
      :disabled="this.qnrIsCompleted"
      @input="
        handleValueChange('medical_history.heart_surgery_details', $event)
      "
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Are you currently on any medications?"
      width="132px"
      mobileWidth="163px"
      :options="yesNoOptions"
      :value="this.cardioQnr.medical_history.on_medications"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('medical_history.on_medications', $event)"
    />
  </div>
  <div
    class="expandedContainer"
    v-if="this.cardioQnr.medical_history.on_medications"
  >
    <div class="mb-[10px]">Please specify</div>
    <el-input
      v-model="this.cardioQnr.medical_history.medication_details"
      class="expandInputField"
      :type="this.dynamic_input_type"
      :disabled="this.qnrIsCompleted"
      @input="handleValueChange('medical_history.medication_details', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Are you currently on any supplements?"
      width="132px"
      mobileWidth="163px"
      :options="yesNoOptions"
      :value="this.cardioQnr.medical_history.on_supplements"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('medical_history.on_supplements', $event)"
    />
  </div>
  <div
    class="expandedContainer"
    v-if="this.cardioQnr.medical_history.on_supplements"
  >
    <div class="mb-[10px]">Please specify</div>
    <el-input
      v-model="this.cardioQnr.medical_history.supplement_details"
      class="expandInputField"
      :type="this.dynamic_input_type"
      :disabled="this.qnrIsCompleted"
      @input="handleValueChange('medical_history.supplement_details', $event)"
    />
  </div>
  <div class="subTitleContainer">
    <div class="subTitle">DIETARY PATTERNS</div>
    <div class="assessmentHint">
      How often do you consume the following?
      <b
        >0 = Rarely&nbsp; &nbsp; 1 = Sometimes&nbsp; &nbsp; 2 = Often&nbsp;
        &nbsp; 3 = Always</b
      >
    </div>
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Diet high in processed foods and sugars"
      width="auto"
      mobileWidth="77.5px"
      :options="frequencyOptions"
      :value="this.cardioQnr.dietary_patterns.high_ultra_processed_diet"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('dietary_patterns.high_ultra_processed_diet', $event)
      "
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="<div class='max-w-[420px]'>Balanced diet (e.g. most meals contain fruits, vegetables, beans, nuts/seeds, whole grains, and lean proteins)</div>"
      width="auto"
      mobileWidth="77.5px"
      :options="frequencyOptions"
      :value="this.cardioQnr.dietary_patterns.balanced_diet"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('dietary_patterns.balanced_diet', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="<div class='max-w-[420px]'>High-fat diet (e.g. ketogenic diet, paleo diet, caveman/carnivore diet)</div>"
      width="auto"
      mobileWidth="77.5px"
      :options="frequencyOptions"
      :value="this.cardioQnr.dietary_patterns.high_fat_diet"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('dietary_patterns.high_fat_diet', $event)"
    />
  </div>
  <div class="subTitleContainer">
    <div class="subTitle">LIFESTYLE</div>
  </div>
  <div class="subpartContainer col-container">
    <QuestionnaireRadio
      content="On average, how often do you engage in physical activity?"
      width="fit-content"
      :options="activeOptions"
      :value="this.cardioQnr.lifestyle.active_level"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('lifestyle.active_level', $event)"
    />
  </div>
  <div class="subpartContainer col-container">
    <QuestionnaireRadio
      content="On average, how often do you engage in different types of physical activity?"
      width="fit-content"
      :options="cardioPhysicalActivityFrequencyOptions"
      :value="this.cardioQnr.lifestyle.physical_activity_frequency"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('lifestyle.physical_activity_frequency', $event)
      "
    />
  </div>
  <div class="subpartContainer col-container">
    <QuestionnaireMultiChoice
      content="What types of physical activity do you engage in?"
      width="fit-content"
      mobileWidth="fit-content"
      :options="cardioPhysicalActivityTypeOptions"
      :value="this.physicalActivityTypeArray"
      :disabled="this.qnrIsCompleted"
      @onChange="handlePhysicalActivityTypeChange"
    />
  </div>
  <div class="subpartContainer col-container">
    <QuestionnaireRadio
      content="How many hours of sleep do you get on average per night?"
      width="247px"
      mobileWidth="fit-content"
      :options="cardioSleepHoursOptions"
      :value="this.cardioQnr.lifestyle.sleep_hours"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('lifestyle.sleep_hours', $event)"
    />
  </div>
  <div class="subpartContainer col-container">
    <QuestionnaireRadio
      content="How would you rate your stress levels"
      width="247px"
      mobileWidth="fit-content"
      :options="stressLevelOptions"
      :value="this.cardioQnr.lifestyle.stress_level"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('lifestyle.stress_level', $event)"
    />
  </div>
  <div class="subpartContainer col-container">
    <QuestionnaireRadio
      content="How often do you engage in any stress-reducing techniques (such as mindfulness, breathing exercises, yoga, prayer, or other relaxation practices)?"
      width="fit-content"
      :options="stressReductionOptions"
      :value="this.cardioQnr.lifestyle.stress_reduction_frequency"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('lifestyle.stress_reduction_frequency', $event)
      "
    />
  </div>
  <div class="subpartContainer col-container">
    <QuestionnaireRadio
      content="During the past 6 months, on average, about how many alcoholic drinks did you have per month?
(One drink = 12 oz beer, 5 oz wine, or 1.5 oz liquor)"
      width="fit-content"
      :options="cardioAlcoholicDrinkingOptions"
      :value="this.cardioQnr.lifestyle.alcohol_use_frequency"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('lifestyle.alcohol_use_frequency', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Do you smoke or use tobacco products?"
      width="132px"
      mobileWidth="163px"
      :options="yesNoOptions"
      :value="this.cardioQnr.lifestyle.nicotine_use"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('lifestyle.nicotine_use', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="<div class='max-w-[500px]'>Have you recently experienced significant stress or mental health issues?</div>"
      width="132px"
      mobileWidth="163px"
      :options="yesNoOptions"
      :value="this.cardioQnr.lifestyle.stress_or_mental_health_issues"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('lifestyle.stress_or_mental_health_issues', $event)
      "
    />
  </div>
</template>

<script>
import QuestionnaireRadio from "./QuestionnaireRadio.vue";
import QuestionnaireMultiChoice from "./QuestionnaireMultiChoice.vue";
import { useCardioQnrStore } from "@/stores/CardioQnrStore.ts";
import { mapState, mapActions } from "pinia";
import { useWindowSize } from "@vueuse/core";

import {
  yesNoOptions,
  severityOptions,
  frequencyOptions,
  activeOptions,
  sleepHoursOptions,
  tabaccoUseOptions,
  alcoholUseOptions,
  stressLevelOptions,
  stressReductionOptions,
  cardioRelatedConditionOptions,
  cardioRelatedFamilyHistoryOptions,
  bowelMovementOptions,
  stoolOptions,
  cardioAlcoholicDrinkingOptions,
  cardioPhysicalActivityFrequencyOptions,
  cardioSleepHoursOptions,
  cardioPhysicalActivityTypeOptions,
} from "@/utils/questionnaireOptions";

export default {
  name: "CardioRelatedQuestions",
  components: {
    QuestionnaireRadio,
    QuestionnaireMultiChoice,
  },
  props: {
    showWarning: Boolean,
  },
  data() {
    return {
      yesNoOptions,
      severityOptions,
      frequencyOptions,
      activeOptions,
      sleepHoursOptions,
      tabaccoUseOptions,
      alcoholUseOptions,
      stressLevelOptions,
      stressReductionOptions,
      cardioRelatedConditionOptions,
      cardioRelatedFamilyHistoryOptions,
      bowelMovementOptions,
      stoolOptions,
      cardioPhysicalActivityFrequencyOptions,
      cardioSleepHoursOptions,
      cardioAlcoholicDrinkingOptions,
      cardioPhysicalActivityTypeOptions,
    };
  },
  setup() {
    const { width } = useWindowSize();
    return {
      width,
    };
  },
  emits: ["removeWarning"],
  watch: {
    bloodPressureChecked: {
      immediate: true,
      handler: function (newValue) {
        if (!newValue) {
          this.handleValueChange(
            "medical_history.blood_pressure_check_details",
            null
          );
        }
      },
    },
    hasHeartSurgeries: {
      immediate: true,
      handler: function (newValue) {
        if (!newValue) {
          this.handleValueChange("medical_history.heart_surgery_details", null);
        }
      },
    },
    onMedications: {
      immediate: true,
      handler: function (newValue) {
        if (!newValue) {
          this.handleValueChange("medical_history.medication_details", null);
        }
      },
    },
    onSupplements: {
      immediate: true,
      handler: function (newValue) {
        if (!newValue) {
          this.handleValueChange("medical_history.supplement_details", null);
        }
      },
    },
  },
  computed: {
    ...mapState(
      () => useCardioQnrStore(),
      [
        "cardioQnr",
        "personalHistoryArray",
        "familyHistoryArray",
        "physicalActivityTypeArray",
        "qnrIsCompleted",
      ]
    ),
    isMobile() {
      return this.width <= 808;
    },
    dynamic_input_type() {
      return this.isMobile ? "textarea" : "text";
    },
    onMedications() {
      return this.cardioQnr.medical_history?.on_medications;
    },
    onSupplements() {
      return this.cardioQnr.medical_history?.on_supplements;
    },
    bloodPressureChecked() {
      return this.cardioQnr.medical_history?.blood_pressure_checked;
    },
    hasHeartSurgeries() {
      return this.cardioQnr.medical_history?.has_heart_surgeries;
    },
  },
  methods: {
    ...mapActions(
      () => useCardioQnrStore(),
      [
        "getCardioQnrData",
        "submitCardioQnr",
        "setCardioQnrSingleField",
        "setPersonalHistoryArray",
        "setFamilyHistoryArray",
        "setPhysicalActivityTypeArray",
        "convertCardioQnrArrayToObject",
        "convertPhysicalActivityTypeArrayToObject",
      ]
    ),
    handleValueChange(key, value) {
      if (key === "medical_history.blood_pressure_checked") {
        this.$emit("removeWarning");
      }
      this.setCardioQnrSingleField(key, value);
    },
    handleNumberInput(key, value) {
      const numericValue = value.replace(/[^\d]/g, '');

      this.setCardioQnrSingleField(key, Number(numericValue));
    },
      
    handlePersonHistoryChange(value) {
      this.setPersonalHistoryArray(value);
      //convert array value to boolean
      this.convertCardioQnrArrayToObject("personal_history", value);
    },
    handleFamilyHistoryChange(value) {
      this.setFamilyHistoryArray(value);
      // convert array value to boolean
      this.convertCardioQnrArrayToObject("family_history", value);
    },
    handlePhysicalActivityTypeChange(value) {
      this.setPhysicalActivityTypeArray(value);
      // convert array value to boolean
      this.convertPhysicalActivityTypeArrayToObject(value);
    },
  },
};
</script>

<style scoped>
.subpartContainer {
  width: 100%;
  padding: 0px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.col-container {
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;
}

.title {
  font-weight: 600;
}

.inputField {
  height: 42px;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.4px;
  color: #000000;
  border-radius: 4px;
  width: 593px;
}

.expandInputField {
  height: 42px;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.4px;
  color: #000000;
  border-radius: 4px;
  width: 760px;
}

:deep(.el-textarea__inner) {
  caret-color: #000 !important;
  white-space: normal;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.4px;
  color: #000000;
  resize: none;
  height: 126px;
  box-shadow: none;
  padding: 12px 16px;
  border: 1px solid #bcccdc;
}

:deep(.el-input__wrapper) {
  box-shadow: none;
  border: 1px solid #bcccdc;
  padding-left: 21px;
}

.subTitleContainer {
  padding: 12px 24px;
  border-radius: 4px;
  background-color: #faece6;
  margin-top: 36px;
  margin-bottom: 24px;
}

.subTitle {
  color: #0e4672;
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0.17px;
}

.assessmentHint {
  font-family: Roboto;
  font-size: 16px;
  margin-top: 8px;
}

.assessmentHint b {
  font-weight: 700;
  font-style: italic;
  display: block;
}

.expandedContainer {
  padding: 12px 24px;
  border-radius: 4px;
  background-color: #f3f6f8;
  margin: 12px 12px;
}

:deep(.el-input__inner) {
  color: #000000;
}

:deep(.el-input.is-disabled .el-input__wrapper) {
  background-color: #f2f2f2;
}

:deep(.el-input.is-disabled .el-input__inner) {
  -webkit-text-fill-color: #1c1c1c;
}

:deep(.el-textarea.is-disabled .el-textarea__inner) {
  background-color: #f2f2f2;
  -webkit-text-fill-color: #1c1c1c;
}

@media only screen and (max-width: 808px) {
  .subpartContainer {
    width: 100%;
    padding: 0px 8px;
    margin-bottom: 12px;
    flex-direction: column;
    align-items: flex-start;
  }

  .inputField {
    width: 334px;
    height: 42px;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0.4px;
  }

  .subpartContainer .title {
    font-size: 14px;
  }

  .subTitleContainer {
    padding: 12px 16px;
    margin-top: 24px;
    margin-bottom: 12px;
  }

  .subTitle {
    font-size: 14px;
    line-height: 16px;
  }

  .expandedContainer {
    padding: 12px 16px;
    margin: 12px 8px;
    font-size: 14px;
  }

  .assessmentHint {
    font-size: 14px;
    line-height: 14px;
  }

  .assessmentHint b {
    margin-top: 8px;
    display: block;
  }

  :deep(.el-textarea__inner) {
    font-size: 14px;
    line-height: 16px;
  }

  .expandInputField {
    height: 100px;
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0.4px;
    color: #000000;
    border-radius: 4px;
    width: 310px;
  }

  .expandedContainer :deep(.el-textarea__inner) {
    height: 100px;
  }
}
</style>
